import React, { Suspense, lazy, useEffect } from "react";
import { SwmcFooter } from "footer-component";
import { Container } from "react-bootstrap";
import "./Footer.css";

const CustomFooter = () => {
  useEffect(() => {
    const replaceFooterLinks = () => {
      // Try multiple selectors to find the links
      const phoneSelectors = [
        'a[href="tel:+18334786937"]',
        'a[href="tel:+1-833-478-6937"]',
        'a[href="tel:8334786937"]'
      ];
      
      const emailSelectors = [
        'a[href="mailto:inquiry@swmc.com"]'
      ];
      
      let phoneReplaced = false;
      let emailReplaced = false;
      
      // Replace phone links
      phoneSelectors.forEach(selector => {
        const links = document.querySelectorAll(selector);
        links.forEach(link => {
          link.href = 'tel:+18558923806';
          link.textContent = '(855) 892-3806';
          phoneReplaced = true;
        });
      });
      
      // Replace email links
      emailSelectors.forEach(selector => {
        const links = document.querySelectorAll(selector);
        links.forEach(link => {
          link.href = 'mailto:contact@chooselowrate.com';
          link.textContent = 'contact@chooselowrate.com';
          emailReplaced = true;
        });
      });
      
      // Also try to find links by text content
      const allLinks = document.querySelectorAll('a');
      allLinks.forEach(link => {
        if (link.textContent.includes('(833) 478-6937') || link.textContent.includes('833-478-6937')) {
          link.href = 'tel:+18558923806';
          link.textContent = '(855) 892-3806';
          phoneReplaced = true;
        }
        if (link.textContent.includes('inquiry@swmc.com')) {
          link.href = 'mailto:contact@chooselowrate.com';
          link.textContent = 'contact@chooselowrate.com';
          emailReplaced = true;
        }
      });
      
      return phoneReplaced || emailReplaced;
    };
    
    // Try multiple times with increasing delays
    const attempts = [0, 100, 500, 1000, 2000];
    const timers = [];
    
    attempts.forEach(delay => {
      const timer = setTimeout(() => {
        replaceFooterLinks();
      }, delay);
      timers.push(timer);
    });
    
    // Set up MutationObserver to watch for DOM changes
    const observer = new MutationObserver(() => {
      replaceFooterLinks();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return () => {
      timers.forEach(timer => clearTimeout(timer));
      observer.disconnect();
    };
  }, []);

  return (
    <div className="footer-page-bg">
      <Container>
        <div>
          <p className="footer-page-disc">
            Visit <a href="https://www.swmc.com/disclaimer" target="_blank">swmc.com/disclaimer</a> for terms and limitations of the Trusted Warranty.<br />
            Although Sun West Mortgage is approved to conduct business in the state of New York, this website has not yet been approved by the State of New York Department of Financial Services.<br/>
            For properties located in the State of New York, this website cannot be used to upload an application, please visit <a href="https://www.swmc.com/" target="_blank">SWMC.com</a> to upload an application.
          </p>
        </div>
      </Container>
      <SwmcFooter type="swmc" showTacanewLogo={true} nydisclaimer={false} />
    </div>
  );
};

export default CustomFooter;